export const getFileAndFnNameObj = (filename)=>(fnName)=>({
    filename,
    fnName
});

